var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { publishAppLoading } from '../../../OnBoarding-V2/Events/utils.events';
import { subscribeInitiateTvePopup } from './tve-login-events';
import V2TveDialogPopup from './V2TveDialogPopup';
import { checkAuthenticationSession, retrieveProfileAgainstMvpdCode } from '../Apis';
import localforage from 'localforage';
import { registerTveUser } from './utils';
import { isTveOnlyLoginEnabled } from '../../../helpers';
var V2TveLogin = function () {
    var _a = __read(useState(false), 2), showDialogBox = _a[0], setShowDialogBox = _a[1];
    var toggleTvePopup = function (data) {
        setShowDialogBox(data);
    };
    var checkTveAuth = function () {
        var tveLoginOnly = isTveOnlyLoginEnabled();
        var params = new URLSearchParams(window.location.search);
        var path = window.location.pathname.includes('checkout') ? '/' : window.location.pathname;
        var selectedMvpdId = localStorage.getItem('selectedMvpdId');
        var userStatus = params.get("isTveUser");
        if (tveLoginOnly && userStatus === 'Authenticated') {
            publishAppLoading(true);
            console.log("Authenticated");
            var data = new URLSearchParams();
            data.append('mvpd', selectedMvpdId);
            checkAuthenticationSession(data).then(function (res) {
                var isAuthenticated = res.data.reasonType;
                if (isAuthenticated == "authenticated" && selectedMvpdId == res.data.mvpd)
                    retrieveProfileAgainstMvpdCode().then(function (res) {
                        var _a, _b, _c, _d;
                        localforage.setItem('tveProfileResponse', res.data.profiles[selectedMvpdId].attributes);
                        registerTveUser({
                            tveUserId: ((_b = (_a = res.data.profiles[selectedMvpdId].attributes) === null || _a === void 0 ? void 0 : _a.userID) === null || _b === void 0 ? void 0 : _b.value) || '',
                            mvpd: selectedMvpdId,
                            encryptedZip: ((_d = (_c = res.data.profiles[selectedMvpdId].attributes) === null || _c === void 0 ? void 0 : _c.zip) === null || _d === void 0 ? void 0 : _d.value) || '',
                            path: path,
                        });
                    })
                        .catch(function (error) {
                        publishAppLoading(false);
                    });
            });
            //
        }
    };
    useEffect(function () {
        checkTveAuth();
        subscribeInitiateTvePopup(toggleTvePopup);
    }, []);
    return (React.createElement(React.Fragment, null, showDialogBox ? React.createElement(V2TveDialogPopup, null) : null));
};
export default V2TveLogin;
